import { render, staticRenderFns } from "./YcJingYing.vue?vue&type=template&id=767ad920&scoped=true"
import script from "./YcJingYing.vue?vue&type=script&lang=js"
export * from "./YcJingYing.vue?vue&type=script&lang=js"
import style0 from "./YcJingYing.vue?vue&type=style&index=0&id=767ad920&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ad920",
  null
  
)

export default component.exports